import { CompanyEditPage } from "@/features/company/pages/CompanyEdit";
import { FC } from "react";

const CompanyEdit: FC = () => {
  return <CompanyEditPage />;
};

export default CompanyEdit;
